import { Component, OnDestroy, OnInit } from '@angular/core';
import { SystemSegment } from 'src/app/models/SystemSegment';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/core/core.interfaces';
import {
  selectSimulationStep,
  selectSystemSegment,
} from 'src/app/core/store/core/core.selectors';
import { filter, takeUntil } from 'rxjs/operators';
import { goToSimulationPage } from 'src/app/core/store/core/core.actions';
import {
  selectAccessType,
  selectBrokerProtheus,
} from 'src/app/core/store/auth/auth.selectors';
import { AccessType } from 'src/app/core/enums/AccessType';
import { BrokerProtheus } from '../../interfaces/BokerProtheus';
import { clearBrokerProtheus } from 'src/app/core/store/auth/auth.actions';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['../auth/auth.component.scss', './create-user.component.scss'],
})
export class CreateUserComponent implements OnInit, OnDestroy {
  systemSegment!: SystemSegment;

  stepDescription!: string;

  destroyed$ = new Subject<void>();

  accessType?: AccessType;

  brokerProtheus?: BrokerProtheus;

  constructor(private store: Store<AppState>) {}

  get title(): string {
    return this.accessType === AccessType.Broker
      ? 'Cadastro corretor(a)'
      : 'Cadastro cliente';
  }

  ngOnInit(): void {
    this.setAccessType();
    this.setSystemSegment();
    this.clearBrokerProtheus();
    this.setBrokerProtheus();

    this.setStepDescription();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  redirectSuccess(): void {
    this.store.dispatch(goToSimulationPage());
  }

  private clearBrokerProtheus(): void {
    this.store.dispatch(clearBrokerProtheus());
  }

  private setBrokerProtheus(): void {
    this.store
      .select(selectBrokerProtheus)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((broker) => {
        this.brokerProtheus = broker;
      });
  }

  private setAccessType(): void {
    this.store
      .select(selectAccessType)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((accessType) => {
        this.accessType = accessType;
      });
  }

  private setStepDescription(): void {
    this.store
      .select(selectSimulationStep)
      .pipe(takeUntil(this.destroyed$), filter(Boolean))
      .subscribe((simulationStep) => {
        const labels: { [key: number]: string } = {
          0:
            this.systemSegment === 'PME'
              ? 'Selecionar Empresa'
              : 'Quem é Você?',
          1: 'Quantidade de Vidas',
          2: 'Preferências',
          3: 'Selecionar Planos',
          4:
            this.systemSegment === 'PME'
              ? 'Dados da Empresa'
              : 'Dados do Titular',
        };

        this.stepDescription = labels[simulationStep] ?? '';
      });
  }

  private setSystemSegment(): void {
    this.store
      .select(selectSystemSegment)
      .pipe(takeUntil(this.destroyed$), filter(Boolean))
      .subscribe((systemSegment) => {
        this.systemSegment = systemSegment;
      });
  }
}
